import styles from "./ExpirationModernWarmup.module.scss"
import useStrings from "../../../localization/useStrings"
import UltimateBackground from "../../../components/UltimateBackground/UltimateBackground"
import svg from "../../../utils/svg"
import images from "../../../utils/images"
import { useExpiration } from "../../../context/expirationContext"
import ExpirationModernPricingSelectionWarmup from "../ExpirationModernPricingSelectionWarmup/ExpirationModernPricingSelectionWarmup"
import CloseButton from "../../../components/CloseButton/CloseButton"
import { useUltimateAlerts } from "../../../context/ultimateAlertsContext"
import ReviewsList from "../../../components/ReviewsList/ReviewsList"
import { useAppState } from "../../../context/appStateContext"

interface Feature {
  title: string
  subtitle: string
  icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>
}

const ExpirationModernWarmup = () => {
  return (
    <div className={styles.container}>
      <Header />
      <Content />
    </div>
  )
}

const Header = () => {
  const { state } = useExpiration()

  const strings = useStrings().expiration.warmup
  const hideWarmup = useExpiration().actions.hideWarmup

  const title = state.canToggleUltimate
    ? strings.titlePremium
    : strings.titleUltimate

  const marginTop = useAppState().state.initialData?.topInset ?? 0

  return (
    <div className={styles.header}>
      <div className={styles.headerBackground}>
        <img
          className={`${images.expiration.warmup.class} ${styles.headerBackgroundImage}`}
        />
      </div>
      <div
        className={styles.closeButtonContainer}
        style={{ marginTop: marginTop + 16 }}
      >
        <div />
        <CloseButton onClick={hideWarmup} className={styles.closeButton} />
      </div>
      <div className={styles.icon}>
        {state.isUltimate ? <svg.UltimateIcon /> : <svg.PremiumIcon />}
      </div>
      <label className={styles.title}>{title}</label>
      <label className={styles.subtitle}>{strings.subtitle}</label>
    </div>
  )
}

const Content = () => {
  const strings = useStrings().comparePlans
  const actions = useUltimateAlerts().actions

  return (
    <div className={styles.content}>
      <ExpirationModernPricingSelectionWarmup />
      <div className={styles.spacer} />
      <FeatureList />
      <button
        className={styles.comparePlans}
        onClick={() => {
          actions.setShowComparePlansSheet(true)
        }}
      >
        {strings.title}
      </button>
      <ReviewsList className={styles.reviews} />
    </div>
  )
}

const FeatureList = () => {
  const strings = useStrings().expiration.warmup
  const isUltimate = useExpiration().state.isUltimate

  const premiumFeatures = [
    {
      ...strings.features.cloudVault,
      icon: svg.featureIcons.CloudVault,
    },
    {
      ...strings.features.reviews,
      icon: svg.featureIcons.Star,
    },
    {
      ...strings.features.noAds,
      icon: svg.featureIcons.Adfree,
    },
  ]

  const ultimateFeatures = [
    {
      ...strings.features.cloudVaultUltimate,
      icon: svg.featureIcons.CloudVault,
    },
    {
      ...strings.features.reviews,
      icon: svg.featureIcons.Star,
    },
    {
      ...strings.features.organizationPlus,
      icon: svg.featureIcons.OrganizationPlus,
    },
  ]

  const features = isUltimate ? ultimateFeatures : premiumFeatures

  return (
    <div className={styles.featuresContainer}>
      {features.map((feature, index) => (
        <FeatureListItem key={index} feature={feature} />
      ))}
    </div>
  )
}

interface FeatureListItemProps {
  feature: Feature
}

const FeatureListItem = ({ feature }: FeatureListItemProps) => {
  return (
    <div className={styles.featureItem}>
      <div className={styles.featureIconContainer}>
        {<feature.icon className={styles.featureIcon} />}
      </div>
      <div className={styles.featureItemTextContainer}>
        <label className={styles.featureTitle}>{feature.title}</label>
        <label className={styles.featureSubtitle}>{feature.subtitle}</label>
      </div>
    </div>
  )
}

export default ExpirationModernWarmup
